// eslint-disable-next-line
export default {
  title: "Contacto",
  data: {
    email: "joseandres.guadarrama@gmail.com",
    phone: "N/A",
  },
};
